module.exports = __webpack_public_path__ + "media/images/expert__selectedArrow-884e4076c2db962fd55a0fd246b404a8.png";